// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3D_7p","item":"PaymentsMobile_item__yNFoM","label":"PaymentsMobile_label__2N3Er","amount":"PaymentsMobile_amount__1UCya"};